@defer (when !loading() && current_weather && current_weather.condition) {
    <h2 style="text-align: center">
        <app-app-string key_name="weather.title"></app-app-string>
    </h2>

    <mat-select class="borderless-select" [value]="viewMode" (selectionChange)="onChangeView($event.value)">
        <mat-option value="current">
            <app-app-string key_name="weather.filter.current"></app-app-string>
        </mat-option>
        <mat-option value="hourly">
            <app-app-string key_name="weather.filter.hourly"></app-app-string>
        </mat-option>
    </mat-select>

    @defer (when !loading()) {
        @if (viewMode === 'current') {
            <div>
                <div class="weather-card">
                    <div class="icon-temp">
                        <img class="icon" [src]="handle__weatherIcon(current_weather.condition.icon)" alt="" />
                        <div class="temp">
                            {{ formatTemp(current_weather.temp_f, current_weather.temp_c) }}
                        </div>
                    </div>
                    <div class="metrics">
                        <div class="wind-row">
                            <div>{{ formatWind(current_weather.wind_mph, current_weather.wind_kph) }}</div>
                            <img class="wind-arrow" src="assets/arrow_up.svg" [style.transform]="windRotation(current_weather.wind_degree)" alt="Wind direction arrow" />
                        </div>
                        <div>{{ formatHumidity(current_weather.humidity) }}</div>
                        <div>{{ formatCloudCover(current_weather.cloud) }}</div>
                    </div>
                </div>
            </div>
        }

        @if (viewMode === 'hourly' && hourly.length) {
            <div class="hourly-scroller" #hourScroller>
                @for (item of hourly; track $index) {
                    <div class="hour-card" [attr.data-hour-index]="$index">
                        <div class="hour">{{ formatHourLocal(item.time_epoch) }}</div>
                        <img class="icon" [src]="handle__weatherIcon(item?.condition?.icon)" alt="" />

                        <div class="temp">{{ formatTemp(item.temp_f, item.temp_c) }}</div>
                        <div class="metric wind">
                            <span>{{ formatWind(item.wind_mph, item.wind_kph) }}</span>
                            <img class="wind-arrow" src="assets/arrow_up.svg" [style.transform]="windRotation(item.wind_degree)" alt="Wind direction arrow" />
                        </div>
                        <div class="metric">{{ formatHumidity(item.humidity) }}</div>
                        <div class="metric">
                            {{ formatRainProbability(item.chance_of_rain) }}
                            <!-- Rain: {{ h.chance_of_rain }}% -->
                        </div>
                    </div>
                }
            </div>
        }
    } @placeholder {
        <p>inner</p>
        <app-loading-indicator></app-loading-indicator>
    }
} @placeholder {
    @if (loading()) {
        <app-loading-indicator></app-loading-indicator>
    }
}
